// extracted by mini-css-extract-plugin
export default {"root":"PlasmicVoidStatusCard_root__RsXF5","text":"PlasmicVoidStatusCard_text__yFVMR"};